"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YearRange = exports.ValidateInputField = exports.MinAgeTimeStamp = exports.MaxAgeTimeStamp = void 0;
require("core-js/modules/es.parse-int.js");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _isLeapYear = _interopRequireDefault(require("dayjs/plugin/isLeapYear"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_dayjs.default.extend(_isLeapYear.default);
const YearRange = exports.YearRange = function YearRange(start, end) {
  let step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  const len = Math.floor((end - start) / step) + 1;
  return Array(len).fill().map((_, idx) => start + idx * step);
};
const MaxAgeTimeStamp = MaxAgeInDay => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - MaxAgeInDay);
  return currentDate.getTime();
};
exports.MaxAgeTimeStamp = MaxAgeTimeStamp;
const MinAgeTimeStamp = MinAgeInDay => {
  if (MinAgeInDay > 365) {
    const currentDate = new Date();
    const maxAgeDate = new Date();
    maxAgeDate.setDate(currentDate.getFullYear() - MinAgeInDay);
    const leapYearCount = countLeapYears(maxAgeDate.getFullYear(), currentDate.getFullYear());
    currentDate.setDate(currentDate.getDate() - (MinAgeInDay + leapYearCount));
    currentDate.setHours(0, 0, 0, 0);
    return currentDate.getTime();
  }
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - MinAgeInDay);
  currentDate.setHours(0, 0, 0, 0);
  return currentDate.getTime();
};
exports.MinAgeTimeStamp = MinAgeTimeStamp;
const countLeapYears = (startYear, endYear) => {
  let count = 0;
  for (let year = startYear; year <= endYear; year += 1) {
    if ((0, _dayjs.default)([year]).isLeapYear()) {
      count += 1;
    }
  }
  return count;
};
const ValidateInputField = (inputValue, fieldName, minYear, maxYear) => {
  if (!inputValue) {
    return "".concat(fieldName, " field is required.");
  }
  const numericValue = parseInt(inputValue, 10);

  // Validate day (1-31)
  if (fieldName === 'Day' && (Number.isNaN(numericValue) || numericValue < 1 || numericValue > 31)) {
    return 'Day must be a number between 1 and 31.';
  }

  // Validate month (1-12)
  if (fieldName === 'Month' && (Number.isNaN(numericValue) || numericValue < 1 || numericValue > 12)) {
    return 'Month must be a number between 1 and 12.';
  }

  // Validate year 
  if (fieldName === 'Year' && (Number.isNaN(numericValue) || numericValue < minYear || numericValue > maxYear)) {
    return 'Year value is invalid.';
  }
  return true;
};
exports.ValidateInputField = ValidateInputField;